module.exports = __webpack_public_path__ + "static/media/40.8172d8c7.svg";